import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// 환경변수 설정 확인
const isSupabaseConfigured = supabaseUrl && 
  supabaseAnonKey && 
  !supabaseUrl.includes('your-project-id') && 
  !supabaseAnonKey.includes('your-anon-key')

// 개발 환경에서 환경변수가 아직 설정되지 않은 경우 경고 출력
if (!isSupabaseConfigured) {
  console.warn('⚠️ Supabase 환경변수가 아직 설정되지 않았습니다. 실제 프로젝트 생성 후 .env.local을 업데이트하세요.')
}

// Supabase 클라이언트 (환경변수 상태에 관계없이 생성)
const supabase = isSupabaseConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    })
  : {
      auth: {
        signInWithOAuth: () => Promise.resolve({ data: null, error: { message: 'Supabase 설정 필요' } }),
        signOut: () => Promise.resolve({ error: null }),
        getSession: () => Promise.resolve({ data: { session: null } }),
        getUser: () => Promise.resolve({ data: { user: null } }),
        onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
      }
    }

// OAuth 설정
const oAuthProviders = {
  google: 'google',
  kakao: 'kakao'
}

// 소셜 로그인 함수
const signInWithProvider = async (provider) => {
  if (!isSupabaseConfigured) {
    return { data: null, error: { message: 'Supabase 설정이 필요합니다' } }
  }

  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: provider,
      options: {
        redirectTo: process.env.NODE_ENV === 'development' 
          ? `http://localhost:3002/?auth=success`
          : `${window.location.origin}/?auth=success`,
        queryParams: provider === 'google' ? {
          access_type: 'offline',
          prompt: 'consent'
        } : {}
      }
    })

    if (error) throw error
    return { data, error: null }
  } catch (error) {
    console.error(`${provider} 로그인 오류:`, error)
    return { data: null, error }
  }
}

// 로그아웃 함수
const signOut = async () => {
  if (!isSupabaseConfigured) {
    return { error: null }
  }

  try {
    const { error } = await supabase.auth.signOut()
    if (error) throw error
    return { error: null }
  } catch (error) {
    console.error('로그아웃 오류:', error)
    return { error }
  }
}

// 사용자 정보 가져오기
const getCurrentUser = () => {
  if (!isSupabaseConfigured) {
    return Promise.resolve({ data: { user: null } })
  }
  return supabase.auth.getUser()
}

// 세션 변경 리스너
const onAuthStateChange = (callback) => {
  if (!isSupabaseConfigured) {
    return { data: { subscription: { unsubscribe: () => {} } } }
  }
  return supabase.auth.onAuthStateChange(callback)
}

// 모든 exports는 파일 최상위에서 선언
export { 
  supabase, 
  oAuthProviders, 
  signInWithProvider, 
  signOut, 
  getCurrentUser, 
  onAuthStateChange 
}